const ITEMS = [
  "CUCINE SU MISURA",
  "BAGNI DI LUSSO",
  "CARTONGESSO TECNICO",
  "IMPIANTI CERTIFICATI",
  "GARANZIA 10 ANNI",
  "CHIAVI IN MANO",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-[#B88E4C]/25 bg-[#161514] py-4"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center gap-10">
        {row.map((t, i) => (
          <span
            key={i}
            className="flex items-center gap-10 whitespace-nowrap font-mono text-xs uppercase tracking-[0.3em] text-[#B88E4C]"
          >
            {t}
            <span className="inline-block h-1.5 w-1.5 rotate-45 bg-[#C85A32]" />
          </span>
        ))}
      </div>
    </div>
  );
}
